// useWindowWidth.js
import { useState, useEffect } from "react";

export function useWindowWidth() {
  const isTabletWidth = (width) => width >= 600 && width <= 1280;

  const getInitialIsTablet = () => {
    if (typeof window === "undefined") return false;
    return isTabletWidth(window.innerWidth);
  };

  const [isTabletDevice, setIsTabletDevice] = useState(getInitialIsTablet);

  useEffect(() => {
    const handleResize = () => {
      if (typeof window !== "undefined") {
        setIsTabletDevice(isTabletWidth(window.innerWidth));
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // initial check

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return { isTabletDevice };
}
